// @flow
// NOTIFICATION CONSTANTS
export const NOTIFICATIONS_LOAD = "NOTIFICATIONS_LOAD";
export const NOTIFICATIONS_READ = "NOTIFICATIONS_READ";
export const NOTIFICATIONS_SHOW = "NOTIFICATIONS_SHOW";
export const NOTIFICATIONS_RESET = "NOTIFICATIONS_RESET";
